import * as React from 'react';

const MOBILE_BREAKPOINT = 768;
const TABLET_BREAKPOINT = 1024;

export function useIsMobile() {
    // Default to false during SSR to avoid hydration mismatches
    const [isMobile, setIsMobile] = React.useState<boolean>(false);

    React.useEffect(() => {
        // Only run on client side
        if (typeof window === 'undefined') {
            return;
        }

        const checkMobile = () => {
            setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        };

        // Set initial value
        checkMobile();

        // Use matchMedia for efficient change detection
        const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
        const handleChange = () => {
            checkMobile();
        };

        // Listen for media query changes
        mql.addEventListener('change', handleChange);

        // Also listen for window resize as fallback
        window.addEventListener('resize', checkMobile);

        return () => {
            mql.removeEventListener('change', handleChange);
            window.removeEventListener('resize', checkMobile);
        };
    }, []);

    return isMobile;
}

export function useIsTabletOrMobile() {
    const [isTabletOrMobile, setIsTabletOrMobile] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        const checkTabletOrMobile = () => {
            setIsTabletOrMobile(window.innerWidth < TABLET_BREAKPOINT);
        };

        checkTabletOrMobile();

        const mql = window.matchMedia(`(max-width: ${TABLET_BREAKPOINT - 1}px)`);
        const handleChange = () => {
            checkTabletOrMobile();
        };

        mql.addEventListener('change', handleChange);
        window.addEventListener('resize', checkTabletOrMobile);

        return () => {
            mql.removeEventListener('change', handleChange);
            window.removeEventListener('resize', checkTabletOrMobile);
        };
    }, []);

    return isTabletOrMobile;
}
